import {
  Badge,
  Box,
  Container,
  ContainerProps,
  Flex,
  Heading,
  Switch,
  Text,
} from '@chakra-ui/react';
import { selectCurrentUserSubscriptionPlan } from '@waitroom/auth';
import { findPlan, planOrder } from '@waitroom/common';
import { CMS } from '@waitroom/models';
import { getRequestData } from '@waitroom/react-query';
import { repeat } from '@waitroom/react-utils';
import { t } from 'i18next';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import CardLoader from '../../../../core/components/Loader/Card/CardLoader';
import { useGetPlans } from '../../../hooks/useGetPlans';
import Product from './Product/Product';

const loader = repeat(
  <CardLoader flexGrow={1} maxW="350px" minW={{ md: '300px' }} image button lines={8} />,
  3,
);

const Pricing = ({ heading, ...rest }: CMS.Pricing & ContainerProps): React.ReactElement | null => {
  const currentPlan = useSelector(selectCurrentUserSubscriptionPlan);
  const [annual, setAnnual] = useState(true);
  const { data, isLoading } = useGetPlans();
  const plans = getRequestData(data);
  const len = plans?.length || 0;

  return (
    <Box {...rest}>
      <Container maxW="container.2xl" px={0}>
        {!!heading && (
          <Heading as="h1" size="4xl" mb={10} textAlign="center">
            {heading}
          </Heading>
        )}
        <Flex align="center" justify="center" fontWeight="bold" gap={4} mb={10}>
          <Text as="span" color={annual ? 'gray.500' : undefined}>
            {t('pricing.monthly')}
          </Text>
          <Switch
            size="2xl"
            colorScheme="black"
            defaultChecked={annual}
            onChange={(ev) => setAnnual(ev.currentTarget.checked)}
          />
          <Flex as="span" align="center" gap={1}>
            <Text as="span" color={annual ? undefined : 'gray.500'}>
              {t('pricing.annually')}
            </Text>
          </Flex>
          <Badge colorScheme="green" py="5px">
            {t('pricing.save')}
          </Badge>
        </Flex>
      </Container>
      <Container maxW="container.2xl" px={0}>
        <Box mx="auto" overflow="auto" pb={2} textAlign="center">
          <Flex
            display="inline-flex"
            gap={[6, 6, 8]}
            direction={{ base: 'column', md: 'row' }}
            align={{ base: 'center', md: 'stretch' }}
            textAlign="left"
          >
            {isLoading
              ? loader
              : planOrder?.map((type) => {
                  const product = findPlan(plans, type);
                  // TEMP: remove free plan from UI
                  if (!product || product.config?.paddleProductName === 'free') return null;
                  return (
                    <Product
                      key={product.id}
                      data={product}
                      w={{ base: 'full', md: `${100 / len}%` }}
                      flexGrow={1}
                      maxW="350px"
                      minW={{ md: '300px' }}
                      annual={annual}
                      currentPlan={currentPlan}
                    />
                  );
                })}
          </Flex>
        </Box>
      </Container>
    </Box>
  );
};
export default Pricing;
